<template>
    <div class="stylists-archive-search">
        <div id="hero" class="page-top-search half-hero left">
            <div class="zipcode-search-wrap w-form">
                <h1 class="stylist-search-page-header">Discover & Book beauty appointments.</h1>
                <form id="search-form" name="search-form" data-name="Search Form" class="zipcode-search-form">
                    <div class="tooltip">
                        <div class="input_container services-input">
                            <img v-bind:src="templateDirectory+'/images/icon-lupa.svg'" class="input_img">
                            <input type="text" class="text-field w-input" maxlength="256" v-model="search" name="search" data-name="stylist search" placeholder="SERVICES" id="sort-search" value="" autocomplete="off" v-on:keyup="submitSearchOnEnter">
                        </div>
                        <span class="tooltiptext" >
                            <div class="sort-block">
                                <div v-if="professions.length">
                                    <div class="sort-items">
                                        <div style="text-align:left;width:100%" v-on:click="getAll()" class="sort-by-item active all"><a href="#">All</a></div><br>
                                        <div v-for="profession in professions"  class="professionDiv" style="width:33%;text-align:left">
                                            <div v-on:click="setSort(profession.profession)" v-bind:class="[removeSpaceFromString(profession.profession), 'sort-by-item']"><a href="#">{{profession.profession}}</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>

                    <div class="input_container location-input">
                        <img v-bind:src="templateDirectory+'/images/icon-location.svg'" class="input_img">
                        <input type="text" class="text-field w-input" maxlength="256" id="autocomplete" onFocus="geolocate()" v-model="location" name="location" data-name="stylist search" placeholder="LOCATION" value="" autocomplete="off" v-on:keyup="submitSearchOnEnter">
                    </div>

                    <input type="button" id="submitSearch" value="Search" v-on:click="submitSearch" data-wait="Please wait..." class="submit-btn w-button">
                </form>
            </div>
        </div>

        <div class="page-top-search half-hero right">
            <div class="overImage">
                <h1 class="stylist-search-page-header">Appointment booking app.<br> For independent stylists.</h1>
                <h3 class="downloadForFree">Download for free.</h3>

                <div class="" style="padding-top:15px">
                    <a rel="noreferrer" href="https://itunes.apple.com/us/app/ring-my-barber-appointments/id1451800946" title="Download RMB App from Apple" target="_blank" class="store-btn in-footer w-inline-block">
                        <img v-bind:src="templateDirectory+'/images/App-Store.png'" alt="App Store" title="App Store">
                    </a>
                    <a rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.ringmystylist.app.rmb&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" title="Download RMB App from Google" target="_blank" class="store-btn in-footer m-r-0 w-inline-block">
                        <img v-bind:src="templateDirectory+'/images/Google-Play.png'" alt="Google Play" title="Google Play">
                    </a>
                </div>
            </div>
            <div class="overlay">
                <img v-bind:src="templateDirectory+'/images/female-hand-mock-p-800.png'" class="right-hero-img">
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {eventBus} from "../main"

    export default {
        name: 'StylistsArchiveSearch',
        data() {
            return {
                search: '',
                location: '',
                sort: '',
                professions: [],
                tooltipVisibleState: true,
                templateDirectory: document.getElementById("template_directory").value,
            }
        },
        created () {
            eventBus.$on('professionsToSearchComponent', (professions) => {
                this.professions = professions
            });

            eventBus.$on('stringNoSpace', (string) => {
                return string;
            });
        },

        mounted() {
            $('.tooltiptext').hide();
            var tooltipOpen = false;
            var searchWidth = 0;

            $('body').on('click', function(e) {
                if ( $(e.target).closest('#sort-search').length && tooltipOpen == false) {
                    $(".tooltiptext").show();
                    tooltipOpen = true;
                }else if ( ! $(e.target).closest('.tooltip').length ) {
                    $('.tooltiptext').hide();
                    tooltipOpen = false;
                }else {
                    tooltipOpen = false;
                }
            });

            $('#sort-search').on('click', function(e) {
                $('.tooltiptext').hide();
            });

            /* Widths */
            var tooltipWidthFix = 0;
            if(window.innerWidth >=480) {
                $('.professionDiv').css('width', '33%')
                tooltipWidthFix = 50;
                //$('.tooltiptext::after').css('left', '20%')
            }else {
                $('.professionDiv').css('width', '50%')
                tooltipWidthFix = 0; //14
                //$('.tooltiptext::after').css('left', '50%')
            }

            searchWidth = $('#search-form').width() - tooltipWidthFix
            $('.tooltiptext').css('width', searchWidth)

            $( window ).resize(function() {
                searchWidth = $('#search-form').width()
                $('.tooltiptext').css('width',searchWidth)

                if(window.innerWidth >=480) {
                    $('.professionDiv').css('width', '33%')
                    //$('.tooltiptext::after').css('left', '20%')
                }else {
                    $('.professionDiv').css('width', '50%')
                    //$('.tooltiptext::after').css('left', '50%')
                }
            });
            /********/

            function getAddress (latitude, longitude) {
                $.ajax('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=AIzaSyD43WrsMyDAB2bnCSJD-DQLKolcuz748go')
                    .then(
                        function success (response) {
                            if(response.status != "OK") {
                                console.log('Request failed. Returned status of', response);
                                return;
                            }
                            $('#locationHidden').val(response.results[4].address_components[1].long_name+' '+response.results[4].address_components[0].long_name);
                            return;
                            return response.results[4].address_components[1].long_name+' '+response.results[4].address_components[0].long_name
                            //eventBus.$emit('searchFetchStylists',['',location])
                        },
                        function fail (status) {
                            return 'fail';
                            //this.location = response.results[4].address_components[1].long_name+' '+response.results[4].address_components[0].long_name
                        }
                    )
            }

            if(document.referrer.indexOf('stylist-profile') !== -1) {
                this.search = (localStorage.hasOwnProperty('search_string')) ? localStorage.getItem('search_string') : '';
                this.location = (localStorage.hasOwnProperty('search_location')) ? localStorage.getItem('search_location') : '';
            } else {
                this.search = '';
                this.location = '';
                localStorage.setItem('search_string', this.search);
                localStorage.setItem('search_location', this.location);
            }

            eventBus.$emit('searchFetchStylists',[this.search,this.location]);

            /*if ("geolocation" in navigator) {
                // check if geolocation is supported/enabled on current browser
                navigator.geolocation.getCurrentPosition(
                    function success(position) {
                        // for when getting location is a success
                        getAddress(position.coords.latitude, position.coords.longitude);

                        setTimeout(function(){
                            var loc = $('#locationHidden').val();
                            $('body').find('#autocomplete').val(loc);
                            //$('body').find('#submitSearch').click();
                            eventBus.$emit('searchFetchStylists',['',loc])
                        }, 2000);
                        //clearTimeout(initialRequest);
                    },
                    function error(error_message) {
                        // for when getting location results in an error
                        //clearTimeout(initialRequest);
                        eventBus.$emit('searchFetchStylists',['',''])
                    }
                );
            } else {
                // geolocation is not supported
                // get your location some other way
                eventBus.$emit('searchFetchStylists',['',''])
            }*/
        },

        props: {},
        methods: {
            submitSearch() {
                var location = document.getElementById("autocomplete").value.split(',')
                location = location[0]
                this.location = location
                localStorage.setItem('search_string', this.search);
                localStorage.setItem('search_location', this.location);
                eventBus.$emit('searchFetchStylists',[this.search,this.location])
            },

            removeSpaceFromString(string) {
                var string = string.split(' ').join('')
                string = string.split('&').join('')
                return string
            },

            setSort(sort) {
                $('.sort-by-item').removeClass('active');
                var classSort = sort.split(' ').join('')
                classSort = classSort.split('&').join('')
                $('.'+classSort).addClass('active');

                this.search = sort;
                $('.tooltiptext').hide();
                //this.tooltipVisibleState = false
            },

            tooltipVisible() {
                //this.tooltipVisibleState = true
            },

            getAll() {
                eventBus.$emit('searchFetchStylists',['all',''])
                this.search = '';
                $('.sort-by-item').removeClass('active');
                $('.all').addClass('active');
            },

            submitSearchOnEnter(e) {
                if (e.keyCode === 13) {
                    this.submitSearch()
                }
            },
        }
    }
</script>

<style>
.tooltip {
    /*width: -webkit-fill-available;*/
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    width: 550px;
    height: fit-content;
    background-color: #555;
    color:black;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: -40px;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
    background-color: white;
    top: 63px;
    left:60px;

    -webkit-box-shadow: 0px 0px 26px 2px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 26px 2px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 26px 2px rgba(0,0,0,0.75);
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 20%;
    margin-left: -5px;
    border-width: 0px 10px 10px 10px;
    border-style: solid;
    border-color: white transparent;
}

.tooltip .tooltiptext {
    
    opacity: 1;
}

.input_container {
    position:relative;

}

.input_img {
    position:absolute;
    left: 9px;
    top: 16px;
    width: 19px;
    margin-left: 5px;
}

.location-input{
    width: 80%;
}

.text-field {
    padding-left: 40px!important;
}

.half-hero{
    display: inline-block;
}

.right-hero-img{
    position: absolute;
    top: 50px;
    right: -70px;
    width: 525px;
}

.stylists-archive-search{
    display:flex;
}

.overlay{
    background-color: black;
    opacity: 0.4;
}

.stylist-search-page-header{
    text-align:left!important;
    line-height: 1.5;
}

#search-form{
    padding-top: 30px;
}

.overImage{
    color:white;
    position:absolute;
    bottom: 20px;
    padding-left: 50px;
    text-align: left;
    z-index:99;
}

.half-hero.left{
    width: 63.5%;
}

.half-hero.right{
    width: 36.5%;
    padding: 0!important;
    position: relative;
    overflow: hidden;
}

.downloadForFree{
    color: #1ec6b8;
}

.page-top-search{
    padding: 10% 3% 2%!important;
}

@media only screen and (max-width: 1370px) {
    .overImage{
        bottom:5px!important;
    }

    .overImage .stylist-search-page-header{
        font-size: 16px!important;
    }
}

@media only screen and (max-width: 1153px) {
    .page-top-search{
        padding: 15% 6% 4%!important;
    }
    .overImage{
        bottom:15px!important;
    }
}

@media only screen and (max-width: 884px) {
    .overImage .stylist-search-page-header{
        font-size: 17px;
    }

    .overImage {
        padding-left: 20px;
    }

    .half-hero.right{
        width:0px!important;
        display:none;
    }

    .half-hero.left{
        width:100%;
    }
}

@media only screen and (max-width: 648px) {
    .page-top-search{
        padding: 25% 6% 4%!important;
    }
}

@media only screen and (max-width: 479px) {
    .location-input{
        width: 100%;
    }
}
</style>